import { Routes } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';
import { RoleGuard } from '../guard/role.guard';
import { PermissionGuard } from '../guard/permission.guard';
import { RoleEnum } from '../../services/auth-api/enums/role.enum';

export const content: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../pages/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
  },
  {
    path: 'settings/users',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: [
        RoleEnum[RoleEnum.Admin]
      ],
    },
    loadChildren: () =>
      import('../../pages/settings/users/users.module').then(
        (m) => m.UsersModule
      ),
  },
  {
    path: 'settings/manage-permissions',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: [
        RoleEnum[RoleEnum.Admin]
      ],
    },
    loadChildren: () =>
      import('../../pages/settings/manage-permissions/manage-permissions.module').then(
        (m) => m.ManagePermissionsModule
      ),
  },
  {
    path: 'chat',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: [
        RoleEnum[RoleEnum.Admin], 
        RoleEnum[RoleEnum.Tramitador],
        RoleEnum[RoleEnum.ChatAdmin]
      ],
    },
    loadChildren: () =>
      import('../../pages/chat/chat.module').then((m) => m.ChatModule),
  },
  {
    path: 'schedules',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: [
        RoleEnum[RoleEnum.Admin], 
        RoleEnum[RoleEnum.Tramitador],
        RoleEnum[RoleEnum.ChatAdmin]
      ],
    },
    loadChildren: () =>
      import('../../pages/schedule/schedule.module').then((m) => m.ScheduleModule),
  },
];
